<template>
    <div class="inference-availability-message">
        <span v-html="textHtml"></span>
    </div>
</template>

<script>
import { MIN_HOURS_FOR_INFERENCE } from '../../../business/const'

export default {
    name: 'InferenceAvailabilityMessage',
    computed: {
        textHtml() {
            return this.$translate('ai_score_will_start_being_available', MIN_HOURS_FOR_INFERENCE)
        }
    }
}
</script>

<style lang="scss" scoped>
.inference-availability-message {
    padding: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: $red-alpha;
    border: 0.1rem solid $red;
    font-size: 14px;
    color: $red;
    height: $wells-sub-header-height;
}
</style>
